export default __webpack_public_path__ + "static/media/signin_banner_En.10763115.jpg";